import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.modul';
import { AppComponent } from './app.component';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAnalytics, getAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
//import { provideFireAuthGuardModule } from '@angular/fire/auth-guard';



import { environment } from '../environments/environment';

//import { IonicStorageModule } from '@ionic/storage-angular';

import {HttpClientModule, HttpClient} from '@angular/common/http';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
//import { AngularFireAuthGuard } from '@angular/fire/auth-guard';

//import {DataService} from './services/data.service';

// AoT requires an exported function for factories

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

//Versuch 1.3.2025
//const firebaseApp = initializeApp(environment.firebase); // Initialize Firebase app

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule, 
    IonicModule.forRoot({ innerHTMLTemplatesEnabled: true }), 
    AppRoutingModule,
    
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
      }
      
    })
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    //provideFirebaseApp(() => firebaseApp),
    provideAuth(() => getAuth()),
    provideAnalytics(() => getAnalytics()),
    provideFirestore(() => getFirestore()), 
    provideFunctions(() => getFunctions(undefined, 'europe-west1')),
    //provideFunctions(() => getFunctions(firebaseApp, 'europe-west1'))
    //AngularFireAuthGuard,
     //provideFireAuthGuardModule(),
    //{ provide: REGION, useValue: 'europe-west1'} //Angular 17, Ionic 8 - nicht benötigt
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
